<script>
import {showTeacherCourseList} from "@/utils/apis";
import {mapActions} from "vuex"
export default {
    data() {
        return {
            course_list: [],
        }
    },
    computed: {
        courseId: {
            get() {
                return this.$store.state.courseId;
            },
            set(val) {
                this.$store.dispatch("updateCourseId", val)
                this.$store.dispatch("updateRandomList", val)
            }
        },
        
    },
    methods: {
        ...mapActions([
            'updateCourseId',
            "updateRandomList"
        ]),
        courseListData() {
            showTeacherCourseList().then(({code, data, msg}) => {
                if (code === 200) {
                    this.course_list = data.course_list || [];
                    if (this.course_list.length) {
                        this.courseId = this.course_list[0].course_id;
                        this.updateRandomList(this.courseId);
                        this.updateCourseId(this.courseId);
                    } else {
                        this.$store.commit("CLEAR_COURSE_RESOURCE");
                    }
                    // const ids = this.course_list.map((c) => Number(c.course_id));
                    // const current = this.$store.state.courseId != null
                    //     ? Number(this.$store.state.courseId)
                    //     : null;
                    // // const valid = current != null && ids.includes(current);
                    // console.log("valid ", valid)
                    // if (!valid) {
                        
                    // }
                }
            })
        },
    },
    mounted() {
        this.courseListData()
    }
}
</script>
<template>
    <div class="layout-container">
        <div class="layout-main">
            <div class="course-list">
                <div class="label">课程：</div>
                <el-select size="small" v-model="courseId">
                    <el-option v-for="(value, index) in course_list" :key="index" :label="value.course_name" :value="value.course_id"></el-option>
                </el-select>
            </div>
            <div class="layout-view">
                <router-view/>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.layout-container {
    width: 100%;
    height: calc(100vh - 110px);
    padding: 20px 0;
    .layout-main {
        width: 1200px;
        margin: 0 auto;
        height: calc(100% - 20px);
        padding: 10px 20px;
        background-color: #FFF;
        .course-list {
            height: 40px;
            padding-left: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;
        }
        .layout-view {
            width: 100%;
            height: calc(100% - 50px);
        }
    }
}

</style>